import Chip from '@ui/Chip';
import Link from '@ui/Link';
import Typography from '@ui/Typography';
import { getEndsInText } from '@utils/dateHelpers';
import {
  getPostImage,
  getPostLink,
  shouldDisablePostCauses,
} from '@utils/post.helper';
import { CampaignType } from 'constants/postType.constants';
import React from 'react';
import ActionBar from './ActionBar';
import DonationProgress from './DonationProgress';
import FundraiserGivingLevels from './FundraiserGivingLevels';
import NonProfitCauses from './NonProfitCauses';
import PostAuthorProfile from './PostAuthorProfile';
import PostVideo from './PostVideo';
import PostMessage from './PostMessage';
import ReactionBar from './ReactionBar';
import PostTypeIndicatorChip from './PostTypeIndicatorChip';
import OrgType from '@/constants/orgType.constant';
import TrackPostVisibility from '../TrackPost/trackPostVisibility';
import NonProfitProfileBar from './NonProfitProfileBar';
import PostImageLink from './PostImageLink';

const getGivingLevels = (project) => {
  if (project) {
    return project.givingLevels.map((level) => {
      return {
        id: level.id,
        title: level.title,
        quantity: level.quantity,
        description: level.description,
      };
    });
  }
  return [];
};

function FundraiserPostBody(props) {
  const { post, type, home, fundRaiseType, orgSlug = null } = props;
  const { sourcePostData } = post;
  const { project } = sourcePostData;
  const nonProfit = post.renderProps.nonProfit;

  const { title, message, endDate, campaignType } = sourcePostData;
  const campaignIcon =
    campaignType === CampaignType.FundRaise
      ? '/assets/icons/fundraise-campaign.svg'
      : '/assets/icons/inkind-campaign.svg';

  const endsInDaysText = getEndsInText(endDate);

  const hasImage = getPostImage(post);
  const hasVideo = post.renderProps.videoUrls && post.renderProps.videoUrls[0];
  let slug = post.renderProps?.company?.name.toLowerCase().replace(/\s+/g, '-');

  slug =
    post.renderProps?.company?.orgType === OrgType.NonProfit
      ? `nonprofit/${slug}`
      : `company/${slug}`;

  const disablePostCauses = shouldDisablePostCauses(home, orgSlug);
  const postLink = getPostLink(post);

  return (
    <TrackPostVisibility post={post} type={type}>
      <div>
        <div className="divide-y px-6 lg:px-4">
          <div className="flex flex-col gap-4 py-6 lg:py-4">
            {!disablePostCauses && nonProfit && nonProfit.causes && (
              <NonProfitCauses
                nonProfit={nonProfit}
                className="border-b pb-4"
              />
            )}

            <PostAuthorProfile post={post} home={home} orgSlug={orgSlug} />
          </div>

          <div className="flex w-full flex-col items-start justify-between gap-2 py-2 lg:flex-row">
            <Link href={postLink}>
              <Typography
                variant="h5"
                className="flex-1 group-hover:text-text-hyperlink">
                {title}
              </Typography>
            </Link>
            <div className="flex w-full items-center justify-between gap-2 lg:w-auto lg:flex-col lg:items-end">
              <PostTypeIndicatorChip
                postType={post.sourcePostType}
                campaignType={post.sourcePostData.campaignType}
                fundRaiseType={fundRaiseType}
                nonProfit={nonProfit}
              />
              <Typography variant="caption" color="textSecondary" className="">
                {endsInDaysText}
              </Typography>
            </div>
          </div>
        </div>

        {hasVideo ? <PostVideo post={post} /> : <PostImageLink post={post} />}

        {nonProfit && <NonProfitProfileBar nonProfit={nonProfit} post={post} />}

        <div className="flex items-start px-6 py-4 lg:items-center lg:px-4">
          <DonationProgress post={post} />
        </div>
        {/* {nonProfit && nonProfit.canReceiveDonations && ( */}
        <div className="flex w-full justify-between gap-2">
          <FundraiserGivingLevels
            post={post}
            className="flex-1 overflow-hidden"
            paddingClass="px-6 lg:px-4"
          />
        </div>
        {/* )} */}
        <div className="flex flex-col gap-6 px-6 lg:px-4">
          <div className="divide-y">
            <div className="py-2">
              <PostMessage message={message} />
            </div>

            <ReactionBar post={post} />

            <div className="flex justify-center py-2">
              <ActionBar post={post} orgSlug={orgSlug} />
            </div>
          </div>
        </div>
      </div>
    </TrackPostVisibility>
  );
}

export default FundraiserPostBody;
